export const FORM_ACTIONS = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view',
} as const;

export type FormAction = (typeof FORM_ACTIONS)[keyof typeof FORM_ACTIONS];
